// package: common
// file: common/platform.proto



export const Platform = {
    PLATFORM_UNDEFINED: 0,
    PLATFORM_IOS: 1,
    PLATFORM_ANDROID: 2,
    PLATFORM_WEB: 3,
};


